import {Button, Card} from "react-bootstrap";

function RecipeCard(props){
    let pUrl = props.recipe.image;
    return (
        <Card style={{ width: '200px' }} className="flex-shrink-0">
            <Card.Img variant="top" src={pUrl} />
            <Card.Body className="d-inline-flex flex-column align-items-center py-1">
                <Button variant="dark" className="w-75" style={{height: "35px"}} onClick={() => props.setRecipeModalShow(true)} >
                    <i className="bi bi-search"/>
                </Button>
            </Card.Body>
        </Card>
    )
}
export default RecipeCard;